import { LuPanelLeftClose } from "react-icons/lu";
import LogoWhite from "../../../assets/logo/logo-white.svg?react";
import { colors, effects } from "../../../design/tokens";

interface SideMenuHeaderProps {
  onCollapse: () => void;
  onLogoClick: () => void;
}

export default function SideMenuHeader({
  onCollapse,
  onLogoClick,
}: SideMenuHeaderProps): JSX.Element {
  return (
    <div className="flex items-center justify-between px-4 pt-2 pb-3">
      <button
        onClick={onCollapse}
        className={`w-10 h-10 flex items-center justify-center ${effects.borderRadius.lg}
          text-dark-text-muted hover:text-dark-text ${colors.hover.backgroundAlt}
          transition-colors duration-200`}
      >
        <LuPanelLeftClose size={22} />
      </button>
      <LogoWhite
        className="h-[26px] w-[126px] cursor-pointer"
        onClick={onLogoClick}
      />
    </div>
  );
}
